<template lang="pug">
  div.fill-height
    SubHeader
    br
    v-container
      v-row
        v-col(v-for='(product, i) in info_products_1', cols='12', md='4', :key='i')
          v-card.mx-auto
            v-img(:src='product.img')
            v-card-title {{ product.title }}
            v-card-text
            p.pa-2 {{ product.text }}
            ul
              li.pa-2(v-for='(list, i) in product.list', :key='i') {{ list }}
            v-card-actions(v-if='product.video')
              v-spacer
              v-btn(color='secondary', :href='product.video', text, @click='show_video = !show_video') Ver Video
    .primary
      v-container
        h1.text-center.secondary--text PET TAG y PET COLLAR
        h4.text-center.secondary--text Sistema de identificación de mascotas
        v-row
          v-col(v-for='(product, i) in info_products_2', cols='12', md='4', :key='i')
            h3.text-center.white--text {{ product.info_1.title }}
            p.text-center.white--text {{ product.info_1.text }}
            h3.text-center.white--text(v-if='product.info_2') {{ product.info_2.title }}
            p.text-center.white--text(v-if='product.info_2') {{ product.info_2.text }}
            ul
              li.white--text(v-for='(item, i) in product.info_1.list', :key='i') {{ item }}
    h1.text-center.secondary--text Productos
    v-container
      v-row
        v-col(v-for='(product, i) in info_products_3', cols='12', md='3', :key='i')
          v-card.mx-auto
            v-img(:src='product.img')
            v-card-title {{ product.title }}
            v-card-text
            p.pa-2 {{ product.text }}
</template>

<script>
// @ is an alias to /src
import SubHeader from '@/components/SubHeader.vue'

export default {
  name: 'Products',
  components: {
    SubHeader,
  },
  data() {
    return {
      show_video: false,
      info_products_1: [
        {
          img: 'http://www.micropetid.com/assets/images/aa.jpg',
          title: 'Chip ID',
          text: 'Es un sistema de identificación subcutáneo, este chip viene en un completo sistema higiénico y desechable, cumpliendo con las normas internacionales y certificaciones ISO 11784-11785 de identificación animal.',
          video: null,
          list: []
        },
        {
          img: 'http://www.micropetid.com/assets/images/aa1.jpg',
          title: 'Caracteristicas',
          text: '',
          video: null,
          list: [
            'Aumenta la posibilidad de que tu peludo en caso de perdida vuelva a casa.',
            'Seguimiento de historia clínica.',
            'Impresión de carné online.',
            'Actualización de información online 24/7/365. El único que te envía notificación a tu celular o correo electrónico.'
          ]
        },
        {
          img: 'http://www.micropetid.com/assets/images/aa2.jpg',
          title: 'Mas información',
          text: '',
          video: 'https://www.facebook.com/Micropetid/videos/vb.756762831099937/791078591001694/?type=3&theater',
          list: [
            'El único que te envía al ser leído el nombre exacto del establecimiento de donde fue escaneado.',
            'Notificación de vencimiento de vacunas.',
            'No migra.',
            'Lo mas importante NO afecta a tu peludo.'
          ]
        },
      ],
      info_products_2: [
        {
          info_1: {
            title: 'El Pet Tag',
            text: 'Es una placa de identificación interactiva, la cual permite brindar la información básica del propietario en el momento de ser escaneado.'
          },
          info_2: {
            title: 'PET COLLAR',
            text: 'Es un Sistema de identificación.',
            list: []
          }
        },
        {
          info_1: {
            title: 'Características',
            text: '',
            list:  [
              'Envía la geo localización del lugar donde fue escaneado, por SMS o vía Mail.',
              'Elaborado con los mas altos Estándares de Calidad ( Norma IP 67).',
              'Seguimiento a Historia clínica.'
            ]
          },
          info_2: null
        },
        {
          info_1: {
            title: 'Características',
            text: '',
            list: [
              'Notificación de vacunas.',
              'Carnés On-line.',
              'Actualización de información 24/7, 365 de manera Online por parte del usuario o Veterinario.'
            ]
          },
          info_2: null
        },
      ],
      info_products_3: [
        {
          img: 'http://www.micropetid.com/assets/images/tee3.jpg',
          title: 'CHIP ID',
          text: 'No es doloroso y mide igual que un grano de arroz.',
        },
        {
          img: 'http://www.micropetid.com/assets/images/tee1.jpg',
          title: 'CHIP ID',
          text: 'Para todas las mascotas.',
        },
        {
          img: 'http://www.micropetid.com/assets/images/tee2.jpg',
          title: 'PET TAG',
          text: 'Placa de identificación interactiva.',
        },
        {
          img: 'http://www.micropetid.com/assets/images/tee.jpg',
          title: 'PET COLLAR',
          text: 'Sistema de identificación.',
        },
      ]
    }
  },
}
</script>
